export default __webpack_public_path__ + "static/media/mystery.ad4774f0.png";